import { HotmartRum } from "@commons/observability"
import { Realm } from "../../../realms/types/realm.interface"
import { TrackingEvent } from "../../trackingEvent"
import { CustomTheme } from "../../types/customTheme.interface"
import { ModeEnum } from "../../types/mode.enum"
import { ApplicationConsumerInformation } from "../../util/brand/types/ApplicationConsumerInformation.interface"
import { HttpRequest } from "../../util/httpRequest"
import { EventInterface } from "../../types/event.interface"

const url = {
    production: "https://hotmart-template.cp.hotmart.com",
    staging: "https://hotmart-template.buildstaging.com",
    local: "https://hotmart-template.buildstaging.com"
}

export class ReadS3Theme implements CustomTheme {
    private baseUrl = url[global.ENV]
    private httpRequest: HttpRequest
    trackingEvent: TrackingEvent

    defaultMode = ModeEnum.DARK
    applicationConsumerInformation: ApplicationConsumerInformation

    constructor(
        applicationConsumerInformation: ApplicationConsumerInformation,
        trackingEvent: TrackingEvent
    ) {
        this.httpRequest = new HttpRequest(this.baseUrl)
        this.applicationConsumerInformation = applicationConsumerInformation
        this.trackingEvent = trackingEvent

        if (!this.applicationConsumerInformation.realm) {
            this.applicationConsumerInformation.realm = "hotmart"
        }
    }

    private get apiPath() {
        return `/${this.applicationConsumerInformation.realm}/${this.applicationConsumerInformation.branding_id}.json`
    }

    private get apiFullUrl() {
        return this.baseUrl + this.apiPath
    }

    private getErrorEvent(error: any): EventInterface {
        return {
            brand: this.brand,
            error: {
                code: String(error?.code),
                message: error?.message || "No error message",
                status: error?.status || 500,
                path: this.apiFullUrl
            }
        }
    }

    get brand(): string {
        return this.applicationConsumerInformation.branding_id ?? ""
    }

    async getTheme(): Promise<Realm> {
        if (!this.brand) return {} as Realm

        try {
            const data = await this.httpRequest.get<{ settings: Realm }>(
                this.apiPath
            )

            return data.settings
        } catch (error: any) {
            const event = this.getErrorEvent(error)

            this.trackingEvent.send(event)

            if (error.requestInfo) {
                HotmartRum.captureException(error)

                return {} as Realm
            }

            HotmartRum.captureException(
                new Error(
                    `[API ReadS3 error] - ${error?.code}: ${error?.message}`
                )
            )

            return {} as Realm
        }
    }
}
